import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'

// Importamos moment-timezone
import moment from 'moment-timezone'

import { useCreateFormularioSuscripcionMutation } from '../../../../store/api/endpoints/formularioSuscripcionApiSlice'
import { openFeedback } from '../../../../store/slices/feedback'

import HeaderVista from '../../../elementos/HeaderVista'
import Input from '../../../elementos/Input'
import Loading from '../../../elementos/Loading'

import Button from '@mui/material/Button'
import { Breadcrumbs, Divider, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'

import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined'
import CheckIcon from '@mui/icons-material/Check'

import TitleIcon from '@mui/icons-material/Title'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import EventBusyIcon from '@mui/icons-material/EventBusy'

export default function FormularioSuscripcionCrear() {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [titulo, setTitulo] = useState('')
    const [desde, setDesde] = useState('')
    const [hasta, setHasta] = useState('')
    const [importe, setImporte] = useState('')

    const [
        crearRegistro,
        {
            isLoading: isLoadingCrearRegistro,
            isSuccess: isSuccessCrearRegistro,
            isError: isErrorCrearRegistro,
            error: errorDataCrearRegistro,
        }
    ] = useCreateFormularioSuscripcionMutation()


    const handleSubmit = (e) => {
        e.preventDefault()

        // 1. Tomamos el string del input (ej: "2026-03-10T10:00")
        // 2. Le indicamos a Moment que esa hora ingresada es de Buenos Aires
        // 3. Lo transformamos a formato ISO (UTC) para el backend
        const body = {
            titulo,
            importe: Number(importe), 
            desde: moment.tz(desde, "America/Argentina/Buenos_Aires").toISOString(),
            hasta: moment.tz(hasta, "America/Argentina/Buenos_Aires").toISOString()
        }
        
        crearRegistro(body)
    }

    useEffect(() => {
        if (isErrorCrearRegistro) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorDataCrearRegistro?.data?.message || 'Ocurrió un error al crear el formulario'
            }))
        }
    }, [isErrorCrearRegistro, errorDataCrearRegistro, dispatch])

    useEffect(() => {
        if (isSuccessCrearRegistro) {
            dispatch(openFeedback({
                severity: 'success',
                message: "¡Suscripción creada con éxito!"
            }))

            navigate("/formularios/formulario-suscripcion") 
        }
    }, [isSuccessCrearRegistro, navigate, dispatch])

    if (isLoadingCrearRegistro) return (<Loading />)

    return (
        <>
            <HeaderVista
                titulo={
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/formularios/formulario-suscripcion">
                            <Typography color="text.primary">Suscripciones</Typography>
                        </Link>
                        <Typography color="text.primary">Crear</Typography>
                    </Breadcrumbs>
                }
                icon={<InventoryOutlinedIcon />}
            />
            <form onSubmit={handleSubmit}>
                <Grid container rowSpacing={2} columnSpacing={2}>
                    
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Input
                            label="Título"
                            icon={<TitleIcon />}
                            value={titulo}
                            onChange={setTitulo}
                            type="text"
                            required
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <Input
                            label="Importe"
                            icon={<AttachMoneyIcon />}
                            value={importe}
                            onChange={setImporte}
                            type="number"
                            required
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <Input
                            label="Desde (Fecha y Hora)"
                            icon={<EventAvailableIcon />}
                            value={desde}
                            onChange={setDesde}
                            type="datetime-local"
                            required
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <Input
                            label="Hasta (Fecha y Hora)"
                            icon={<EventBusyIcon />}
                            value={hasta}
                            onChange={setHasta}
                            type="datetime-local"
                            required
                        />
                    </Grid>

                    <Grid size={{ xs: 12 }}>
                        <Divider sx={{ my: 2 }} />
                    </Grid>

                    <Grid size={{ xs: 12 }}>
                        <Button type="submit" variant="contained" color="success" startIcon={<CheckIcon />} >
                            Guardar
                        </Button>
                    </Grid>

                </Grid>
            </form>
        </>
    )
}